import { isAllowed } from 'api/Apollo/allower';
import permissions from 'api/Apollo/permissions';

export default function isAllowedToWriteTags() {
  return isAllowed(permissions.writeTags);
}
